import { useState } from 'react';

const FAQS = [
  {
    q: 'Who provides industrial quality systems near me in Kansas City?',
    a: 'KC Quality Systems provides industrial parts washers and aqueous cleaning systems in the Kansas City area. Based in Prairie Village, KS, our team builds reliable American-made MAXJET systems for commercial and industrial environments. Call 866-540-7575 or email sales@kc-qualitysystems.com to get started.',
  },
  {
    q: 'How much do industrial parts washing systems cost?',
    a: 'Costs vary by system type, size, and configuration. Basic cabinet washers start competitively, while custom conveyor and large-format systems are quoted to your exact requirements. Contact us at 866-540-7575 or sales@kc-qualitysystems.com for a customized quote tailored to your operation and budget.',
  },
  {
    q: 'How long does parts washer installation take?',
    a: 'Standalone cabinet washers can be operational within days of delivery. Custom conveyor and wash bay installations typically take one to several weeks. Every project follows a structured timeline ensuring accuracy, safety compliance, and full operational performance from day one.',
  },
  {
    q: 'Can KC Quality Systems build a custom parts washer for my application?',
    a: 'Yes — custom system design is a core specialty. We\'ve engineered systems for Caterpillar dealers, military rebuilding, aerospace, mining, and steel mold cleaning. With 25+ years of experience, we build each system around your specific parts, volumes, and operational workflow.',
  },
  {
    q: 'Does KC Quality Systems offer leasing or financing options?',
    a: 'Yes. We offer leasing and lease-to-own options, allowing businesses to acquire the right equipment without large upfront capital. This makes it easy to get a MAXJET system while managing cash flow. Visit our Lease to Own page or call us for full program details.',
  },
  {
    q: 'What industries does KC Quality Systems serve in the Midwest?',
    a: 'We serve automotive, aerospace, military, mining, electric motor repair, steel manufacturing, gas compressor rebuilding, and general industrial markets. If your operation requires precision parts cleaning or surface finishing, we have a proven, compliance-ready solution ready to deliver.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="bg-obsidian py-32">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="text-gold text-xs font-semibold tracking-[0.4em] uppercase font-sans">FAQ</span>
          <h2 className="font-serif text-4xl text-white mt-4 mb-4">Frequently Asked Questions</h2>
          <p className="text-white/40 font-sans text-lg max-w-xl mx-auto">
            Everything you need to know about our industrial cleaning and finishing systems.
          </p>
        </div>

        <div className="space-y-2">
          {FAQS.map((faq, idx) => (
            <div
              key={idx}
              className={`rounded-xl border overflow-hidden transition-all duration-300 ${
                open === idx
                  ? 'border-gold/25 bg-[#0e0e0e]'
                  : 'border-[#181818] bg-[#0a0a0a] hover:border-[#252525]'
              }`}
            >
              <button
                className="w-full flex items-start justify-between px-6 py-5 text-left gap-5 cursor-pointer"
                onClick={() => setOpen(open === idx ? null : idx)}
              >
                <span
                  className={`font-sans text-sm leading-relaxed font-medium transition-colors ${
                    open === idx ? 'text-gold' : 'text-white/75'
                  }`}
                >
                  {faq.q}
                </span>
                <div
                  className={`w-7 h-7 flex items-center justify-center rounded-full border flex-shrink-0 mt-0.5 transition-all ${
                    open === idx
                      ? 'border-gold bg-gold/10 rotate-45'
                      : 'border-[#2a2a2a] text-white/25'
                  }`}
                >
                  <i className={`ri-add-line text-xs ${open === idx ? 'text-gold' : ''}`} />
                </div>
              </button>
              {open === idx && (
                <div className="px-6 pb-6">
                  <div className="border-l border-gold/20 pl-4">
                    <p className="text-white/50 font-sans text-sm leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/25 text-sm font-sans mb-5">Still have questions? We&apos;re happy to help.</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="tel:8665407575"
              className="inline-flex items-center gap-2 px-7 py-3.5 border border-[#222] rounded-lg text-white/55 text-sm font-sans hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line text-gold" />
              Call 866-540-7575
            </a>
            <a
              href="mailto:sales@kc-qualitysystems.com"
              className="inline-flex items-center gap-2 px-7 py-3.5 border border-[#222] rounded-lg text-white/55 text-sm font-sans hover:border-gold hover:text-gold transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line text-gold" />
              Email Our Team
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-gold text-black font-bold text-sm font-sans rounded-lg hover:bg-gold-light transition-colors cursor-pointer whitespace-nowrap"
            >
              Schedule a Consultation
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
